<template>
  <div>
    <div class="menu-switch"></div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
       <el-menu
          :default-active="onRoutes"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="#ffffff"
          text-color="#000000"
          active-text-color="#409EFF">
          <SidebarItem v-for="(item,index) in sidebar" :key="index" :item="item" v-if="item.isLink" />
          <div v-for="(item,index) in sidebar" class="menu-wrapper-s" v-if="!item.isLink">
            <a :href="item.path">
              <span>{{ item.title }}</span>
            </a>
          </div>
        </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  data() {
    return {
      sidebar: [],
      document:[
        {
          'key':'1',
          'title':this.$root.lang.docMenu.base,
          'isLink': true,
          'path':'/base'
        },
        {
          'key':'3',
          'title':this.$root.lang.docMenu.demo,
          'isLink': true,
          'kindOne':[
              {
              'key':'3-1',
              'title':this.$root.lang.docMenu.demoItem.socket,
              'isLink': true,
              'path':'/demo/socket'
              },
              {
              'key':'3-3',
              'title':this.$root.lang.docMenu.demoItem.uart,
              'isLink': true,
              'path':'/demo/uart'
              },
              {
              'key':'3-4',
              'title':this.$root.lang.docMenu.demoItem.file,
              'isLink': true,
              'path':'/demo/file'
              },
              {
              'key':'3-5',
              'title':this.$root.lang.docMenu.demoItem.deviceInfo,
              'isLink': true,
              'path':'/demo/deviceInfo'
              }
          ]
        },
        {
          'key':'4',
          'title':this.$root.lang.docMenu.device,
          'isLink': true,
          'kindOne':[
            {
              'key':'4-1',
              'title':this.$root.lang.docMenu.deviceItem['2G'],
              'isLink': true,
              'path':'/device/2G',
              'kindTwo':[
                {
                'key': '4-1-1',
                'title': this.$root.lang.docMenu.deviceItem['2G1'],
                'isLink': true,
                'path': '/device/explain',
                },
                {
                'key': '4-1-2',
                'title': this.$root.lang.docMenu.deviceItem['2G2'],
                'isLink': true,
                'path': '/device/manual',
                },
              ]
            },
            {
              'key':'4-2',
              'title':this.$root.lang.docMenu.deviceItem['esp'],
              'isLink': true,
              'kindTwo':[
                {
                'key': '4-2-1',
                'title': this.$root.lang.docMenu.deviceItem['esp1'],
                'isLink': true,
                'path':'/josh/megaesp32/expalin'
                },
                {
                'key': '4-2-2',
                'title': this.$root.lang.docMenu.deviceItem['esp2'],
                'isLink': true,
                'path':'/josh/megaesp32/manual'
                },
              ]
            }
          ]
        },
        {
          'key':'5',
          'title':this.$root.lang.docMenu.otherDevice,
          'isLink': true,
          'kindOne':[
            {
              'key':'5-1',
              'title':this.$root.lang.docMenu.otherDeviceItem['wroverkit'],
              'isLink': true,
              'kindTwo':[
                {
                'key': '5-1-1',
                'title': this.$root.lang.docMenu.otherDeviceItem['wroverkit1'],
                'isLink': true,
                'path':'/esp32/update'
                },
                {
                'key': '5-1-2',
                'title': this.$root.lang.docMenu.otherDeviceItem['wroverkit2'],
                'isLink': true,
                'path':'/esp32/develop'
                },
              ]
            },
            {
              'key':'5-2',
              'title':this.$root.lang.docMenu.otherDeviceItem['mini'],
              'isLink': true,
              'kindTwo':[
                {
                'key': '5-2-1',
                'title': this.$root.lang.docMenu.otherDeviceItem['mini1'],
                'isLink': true,
                'path':'/esp32/mini/update'
                },
                {
                'key': '5-2-2',
                'title': this.$root.lang.docMenu.otherDeviceItem['mini2'],
                'isLink': true,
                'path':'/esp32/mini/develop'
                },
              ]
            }
          ]
        },
        {
          'key':'6',
          'title':this.$root.lang.docMenu.resource,
          'isLink': true,
          'path':'/resource/index'
        },
        {
          'key':'7',
          'title':this.$root.lang.docMenu.api,
          'isLink': false,
          'path':'https://file.joshvm.com/document/JavaAPI/'
        },
      ],
      develop:[
        {
          'key':'1',
          'title': this.$root.lang.devMenu.introduce,
          'isLink': true,
          'path':'/develop/base'
        },
        {
          'key':'2',
          'title': this.$root.lang.devMenu.regist,
          'isLink': true,
          'kindOne':[
            {
              'key':'2-1',
              'title':this.$root.lang.devMenu.registItem['develop'],
              'isLink': true,
              'path':'/develop/regist/dev'
            }
          ]
        },
        {
          'key':'3',
          'title': this.$root.lang.devMenu.device,
          'isLink': true,
          'kindOne':[
            {
              'key':'3-1',
              'title':this.$root.lang.devMenu.deviceItem['device'],
              'isLink': true,
              'path':'/develop/deviceManage/device'
            },
            {
              'key':'3-2',
              'title':this.$root.lang.devMenu.deviceItem['group'],
              'isLink': true,
              'path':'/develop/deviceManage/group'
            },
            {
              'key':'3-3',
              'title':this.$root.lang.devMenu.deviceItem['task'],
              'isLink': true,
              'path':'/develop/deviceManage/task'
            }
          ]
        },
        {
          'key':'4',
          'title': this.$root.lang.devMenu.app,
          'isLink': true,
          'path':'/develop/appmanage'
        },
        {
          'key':'5',
          'title': this.$root.lang.devMenu.user,
          'isLink': true,
          'path':'/develop/user'
        },
        {
          'key':'6',
          'title': this.$root.lang.devMenu.overview,
          'isLink': true,
          'path':'/develop/base/overview'
        },
      ]
    }
  },
  computed: {
    onRoutes(){
      return this.$route.path;
    }
  },
  watch: {
    '$route': function (value) {
      var parent = value.meta.parent
      this.sidebar = this[parent]
    }
  },
  created() {
    var parent = this.$route.meta.parent
    this.sidebar = this[parent]
  },
  methods: {
    handleOpen(key, keyPath) {

    },
    handleClose(key, keyPath) {

    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .menu-wrapper-s {
    height: 56px;
    width: 100%;
  }
  .menu-wrapper-s:hover {
    background-color: #cccccc;
  }
  .menu-wrapper-s a {
    display: block;
    padding: 0 20px;
    height: 100%;
    // padding-left: 20px;
    overflow: hidden;
    text-decoration: none;
    font-size: 14px;
    line-height: 56px;
    color: #000;

  }
  .menu-wrapper-s span {
    display: inline-block;
    min-width: 88px;
    text-align: left;
    padding-left:5px;
  }
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue